// SEC-02: web session storage.
//
// The DURABLE credential — the rotating 30-day refresh token — now lives ONLY in
// a Secure/HttpOnly/SameSite cookie set by the backend and is never touched by JS,
// so an XSS on the origin can no longer read a month-long skeleton key (the whole
// point of SEC-02). The short-lived (30-min) access token is kept in localStorage
// so it persists across tabs and browser restarts. Non-credential user info
// remains in sessionStorage.
//
// Every place that used to read localStorage "token" / "refreshToken" / "userInfo"
// must go through this module.

const ACCESS_KEY = "token";
const USERINFO_KEY = "userInfo";

export const getToken = () => {
  try {
    return localStorage.getItem(ACCESS_KEY);
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(ACCESS_KEY, token);
    else localStorage.removeItem(ACCESS_KEY);
  } catch {
    /* storage disabled — nothing to do */
  }
};

export const getUserInfo = () => {
  try {
    return JSON.parse(sessionStorage.getItem(USERINFO_KEY) || "{}");
  } catch {
    return {};
  }
};

export const setUserInfo = (info) => {
  try {
    sessionStorage.setItem(USERINFO_KEY, JSON.stringify(info || {}));
  } catch {
    /* ignore */
  }
};

// Tear down client session state, including legacy storage entries.
export const clearSessionStorage = () => {
  try {
    sessionStorage.removeItem(ACCESS_KEY);
    sessionStorage.removeItem(USERINFO_KEY);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userInfo");
  } catch {
    /* ignore */
  }
};
